// hooks/useImagePreviewTabTrap.js
import { useEffect } from 'react';

const useImagePreviewTabTrap = (visibleImage, previewImg) => {
	useEffect(() => {
		if (!visibleImage || !previewImg) return;

		const timer = setTimeout(() => {
			const prevBtn = document.querySelector('.ant-image-preview-switch-left');
			const nextBtn = document.querySelector('.ant-image-preview-switch-right');

			if (prevBtn) {
				prevBtn.setAttribute('tabindex', '0');
				prevBtn.setAttribute('role', 'button');
				prevBtn.setAttribute('aria-label', 'Previous image');
			}
			if (nextBtn) {
				nextBtn.setAttribute('tabindex', '0');
				nextBtn.setAttribute('role', 'button');
				nextBtn.setAttribute('aria-label', 'Next image');
			}

			const previewRoot = document.querySelector('.ant-image-preview-wrap');
			if (previewRoot) previewRoot.setAttribute('tabindex', '-1');

			//   const firstBtn = toolbar?.querySelector('button:not([disabled])');
			//   firstBtn?.focus();
		}, 200);

		const handleTab = (e) => {
			if (e.key !== 'Tab') return;
			if (!visibleImage) return;

			const toolbar = document.querySelector('.toolbar-wrapper');
			const prevBtn = document.querySelector('.ant-image-preview-switch-left');
			const nextBtn = document.querySelector('.ant-image-preview-switch-right');
			const closeBtn = document.querySelector('[data-preview-close="true"]');
			const viewAllBtn = document.querySelector('[data-preview-viewall="true"]');
			// const otherToolbarButtons = toolbarButtons.filter(el => el !== closeBtn && el !== viewAllBtn);
			const candidates = [
				closeBtn,
				viewAllBtn,
				prevBtn,
				nextBtn,
				...(toolbar?.querySelectorAll('button:not([disabled]), [tabindex="0"]') || []),
			].filter(el => {
				if (!el) return false;
				if (el.classList.contains('ant-image-preview-switch-left-disabled')) return false;
				if (el.classList.contains('ant-image-preview-switch-right-disabled')) return false;
				const s = window.getComputedStyle(el);
				return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
			});

			if (!candidates.length) return;

			const first = candidates[0];
			const last = candidates[candidates.length - 1];
			const active = document.activeElement;

			const isInsidePreview = [toolbar, prevBtn, nextBtn]
				.some(el => el?.contains(active));

			if (!isInsidePreview) {
				e.preventDefault();
				first.focus();
				return;
			}

			const currentIndex = candidates.indexOf(active);

			if (e.shiftKey) {
				e.preventDefault();
				(currentIndex <= 0 ? last : candidates[currentIndex - 1]).focus();
			} else {
				e.preventDefault();
				(currentIndex >= candidates.length - 1 ? first : candidates[currentIndex + 1]).focus();
			}
		};

		const handleEnter = (e) => {
			if (e.key !== 'Enter' && e.key !== ' ') return;
			const active = document.activeElement;
			if (!active) return;

			// Prev/Next divs — not real buttons, need manual click
			if (
				active.classList.contains('ant-image-preview-switch-left') ||
				active.classList.contains('ant-image-preview-switch-right')
			) {
				e.preventDefault();
				active.click();
				return; // ← stop here, don't fall through
			}

			// Toolbar buttons (zoom in, zoom out, close)
			const btn = active.closest('button');
			if (btn && document.querySelector('.toolbar-wrapper')?.contains(btn)) {
				e.preventDefault();
				btn.click();
			}
		};

		document.addEventListener('keydown', handleTab);
		document.addEventListener('keydown', handleEnter);

		return () => {
			clearTimeout(timer);
			document.removeEventListener('keydown', handleTab);
			document.removeEventListener('keydown', handleEnter);
		};
	}, [visibleImage, previewImg]);
};

export default useImagePreviewTabTrap;
